export default __webpack_public_path__ + "static/media/tehran-uni.19318619.png";